import { DeepReadonly } from 'utility-types';
import {
  BillingPeriodSummary,
  UserSubscriptionBillingCycleUsageSummary,
  InstitutionMonthlyUsageData,
} from './types';

export type InstitutionUsageState = DeepReadonly<{
  subscriptionId: string | null;
  billingCycleUsageSummary: UserSubscriptionBillingCycleUsageSummary | null;
  monthlyUsageSummary: InstitutionMonthlyUsageData | null;
  billingPeriodSummary: BillingPeriodSummary | null;
  usageForSubscription: UserSubscriptionBillingCycleUsageSummary | null;
}>;

export const INITIAL_STATE: InstitutionUsageState = {
  subscriptionId: null,
  billingCycleUsageSummary: null,
  monthlyUsageSummary: null,
  billingPeriodSummary: null,
  usageForSubscription: null,
};
